module.exports = __webpack_public_path__ + "static/media/invoicetabsimg.755ba1e3.png";